import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CardFidItem from "../../components/FIOFID/CardFidItem";
import AddToWallet from "../../components/home/AddToWallet/AddToWallet";
import AppNavbar from "../../components/shared/AppNavbar/AppNavbar";
import { useConfig } from "../../context/ConfigContext";
import LeftArrow from "../../images/arrow-left_grey.svg";
import ImgRes from "../../images/Restaurant-img-test.png";
import SearchIcon from "../../images/SearchIconGrey.svg";
import {
  GoogleWalletParams,
  LoyaltyRestaurantsResponse,
} from "../../interfaces/loyality.interface";
import { loyalityApi } from "../../services/loyalityApi";
import { getmyprofile } from "../../store/actions/actions";
import { RootState } from "../../store/rootState";
import { getIcon, IconType } from "../../theme/icons";
import { convertHexToByteArray } from "../../utils/imagesUtils";
import { handleCopy } from "../../utils/textUtils";
import "./FiofidPage.scss";

export default function FiofidPage() {
  const { config } = useConfig();
  const { companyId } = config || {};
  const dispatch = useDispatch();
  const userInfo = useSelector((state: RootState) => state.auth.userInfo);
  let byteArray = convertHexToByteArray(userInfo?.qrCodeBytes || "");
  const blob = new Blob([byteArray], { type: "image/jpeg" });
  const qrCodeUrl = URL.createObjectURL(blob);

  const [RestorentFilter, setRestorentFilter] = useState("");
  const [showQrCode, setShowQrCode] = useState(false);
  const [copied, setCopied] = useState(false);
  const [restaurants, setRestaurants] = useState<LoyaltyRestaurantsResponse>();
  const [loading, setLoading] = useState<boolean>(true);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [addingToGoogleWallet, setAddingToGoogleWallet] =
    useState<boolean>(false);
  const [addingToAppleWallet, setAddingToAppleWallet] = useState(false);
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    !(typeof (window as any).MSStream !== "undefined");

  useEffect(() => {
    dispatch(getmyprofile());
  }, []);

  useEffect(() => {
    const getLoyaltyRestaurants = async () => {
      try {
        setLoading(true);
        const isMarqueBlanche = companyId != null && companyId != undefined;
        const data = await loyalityApi.fetchLoyaltyRestaurants(
          searchQuery,
          isMarqueBlanche
        );

        setRestaurants(data.data);
      } catch (err: any) {
        console.error("Failed to load restaurants", err.message);
      } finally {
        setLoading(false);
      }
    };

    getLoyaltyRestaurants();
  }, [searchQuery]);

  const HandelQrCode = () => {
    setShowQrCode((prevState) => !prevState);
  };

  return (
    <div className="FIOFID">
      <AppNavbar
        setRestorentFilter={setRestorentFilter}
        RestorentFilter={RestorentFilter}
      />
      <div className="TopPageHeader">
        <Link to="/">
          <div>
            <img src={LeftArrow} alt="" />
            <p>FIOFID</p>
          </div>
        </Link>
      </div>
      <div className="listing-cards">
        <div className="qr-code">
          <p className="title-code">
            Scannez le QR code pour profiter des avantages Fidélité !
          </p>
          <div className="fl_row ai_c qr-wrapper jc_s">
            <div className="fl_row ai_c">
              <div className="qrCode fl_row" onClick={HandelQrCode}>
                <img width={"60px"} src={qrCodeUrl} alt="" />
              </div>
              <div className="code-info fl_col">
                <p className="title">Code FID</p>
                <div className="fl_row">
                  <p className="code">{userInfo?.qrCodeValue}</p>
                </div>
              </div>

              <AddToWallet />
            </div>

            {restaurants?.isLoyaltyCentralized && (
              <div className="solde-fio fl_row ai_c ">
                <p className="p16">
                  {restaurants?.loyalties[0]?.totalLoyaltyPoints}
                </p>
                {getIcon(IconType.FioFidStar, {
                  color: config?.primaryColor,
                })}
              </div>
            )}
          </div>
          <div
            className={`qrCode-large ${showQrCode ? "showQrCode" : ""}`}
            onClick={() => HandelQrCode()}
          >
            <div className="overlay">
              <div className="wrapper">
                <img src={qrCodeUrl} alt="" />
              </div>
            </div>
          </div>
        </div>
        {restaurants?.loyalties?.length! > 1 && (
          <div className="ListFilter fl_col">
            <p className="title-filter">Rechercher un restaurant</p>
            <div className="filter-field">
              <img src={SearchIcon} alt="" />
              <input
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                type="text"
                placeholder="Recherche..."
              />
            </div>
          </div>
        )}
        <div className="FidSection">
          <div className="section-wrapper">
            {loading ? (
              <div className="center-message">Loading...</div>
            ) : (
              <div className="list-section">
                {restaurants?.loyalties?.length === 0 ? (
                  <div className="center-message">Aucun restaurant trouvé!</div>
                ) : (
                  restaurants?.loyalties?.map((restaurant) => {
                    return (
                      <CardFidItem
                        key={restaurant?.id}
                        restaurantId={restaurant?.id}
                        restaurantName={restaurant?.name}
                        restaurantImg={ImgRes}
                        points={restaurant?.totalLoyaltyPoints}
                        isLoyaltyCentralized={restaurants?.isLoyaltyCentralized}
                      />
                    );
                  })
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
